export const isNumber = (val: string) => /^-?\d*\.?\d*$/.test(val);

export const isValidNumber = (val: string) => /^(0|[1-9]\d*)(\.\d+)?$/.test(val);
